import * as u from './utils';
import { slideDown, slideUp } from 'slide-anim';

export default () => {
    for (const el of document.getElementsByClassName('js-accordion')) {
        const trigger = el.querySelector('.js-trigger');
        const content = el.querySelector('.js-content');

        trigger.addEventListener('click', () => {
            if (u.hasClass(el, 'is-animating')) {
                return false;
            }

            u.addClass(el, 'is-animating');
            u.toggleClass(el, 'is-active');

            if (u.hasClass(el, 'is-active')) {
                slideDown(content);
            } else {
                slideUp(content);
            }

            setTimeout(() => {
                u.removeClass(el, 'is-animating');
            }, 400);
        });
    }
};
